export default __webpack_public_path__ + "static/media/marketing-app.261591cc.png";